import Button from "components/base/Button";
import UserSelector from "components/shared/UserSelector";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import CreateAccountView from "./accounts/CreateAccountView";
import InvitationForm from "./accounts/InvitationForm";
import { CustomerContext } from "./CustomerPage";
import SubAccountsView from "./SubAccountsView";

const CustomerPortalView = () => {
  const modal = useModals();
  const invigationModal = useModals();

  const { customer, save } = useContext(CustomerContext);

  function showUserSelector() {
    modal.present({
      title: "Choose Account",
      subtitle: "Select an existing user to associate with this customer.",
      children: (
        <UserSelector onSelectUser={didSelectUser} fetchPolicy="network-only" />
      ),
    });
  }

  function tryCreateAccount() {
    modal.present({
      title: "Create New Account",
      subtitle: "Create a new account and associate it with this customer.",
      children: (
        <CreateAccountView customer={customer} onCreated={didSelectUser} />
      ),
    });
  }

  function didSelectUser(user) {
    modal.hide();
    save({ variables: { id: customer.id, userId: user.id } });
  }

  function tryRemoveUser() {
    if (
      window.confirm(
        "Are you sure you want to remove the user from this customer? Once removed, the user will no longer have access to the customer portal.",
      )
    ) {
      save({
        variables: { id: customer.id, removeFields: ["user"] },
      });
    }
  }

  function trySendInvitation() {
    invigationModal.present({
      title: "Send Invitation",
      children: (
        <InvitationForm customer={customer} hide={invigationModal.hide} />
      ),
    });
  }

  return (
    <div className="card">
      <h5>BIZ - Customer Portal</h5>
      <div className="mt-1 opacity-70">
        Customer Portal allows customers to view their price list, orders,
        shipments, download invoices, access marketing materials, and more.
      </div>

      {customer.odooPartnerId ? (
        <div className="mt-2 space-y-2">
          <div className="flex items-center space-x-3">
            <label>Primary Account: </label>
            <b>{customer.user?.email ?? "Not Set"}</b>
          </div>

          <div className="flex space-x-4">
            <Button onClick={tryCreateAccount}>Create New</Button>
            <Button onClick={showUserSelector}>Choose</Button>
            {customer.user && (
              <Button danger onClick={tryRemoveUser}>
                Remove
              </Button>
            )}
          </div>

          {customer.user && (
            <>
              <SubAccountsView />

              <div className="pt-2 border-t border-gray-100 dark:border-gray-700">
                <Button send onClick={trySendInvitation}>
                  Send Invivation
                </Button>
              </div>
            </>
          )}
        </div>
      ) : (
        <div className="mt-2 text-red-600">
          Please connect this customer to an Odoo customer first to enable the
          customer portal.
        </div>
      )}
    </div>
  );
};

export default CustomerPortalView;
